import styled from 'styled-components';

export const ListItemSkeletonStyled = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 0 12px;
  height: 40px;
  margin-bottom: 8px;
   background: ${props => props.theme.uiColors.boxBgColor01};
  border: 1px solid ${props => props.theme.uiColors.tableListRowBorder};
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);

  .DCOSkeleton {
    &__priority,
    &__context,
    &__wrapper,
    &__count,
    &__link,
    &__edit,
    &__more {
      display: flex;
      align-items: center;
    }

    &__priority {
      flex: 0 0 70px;
      display: flex;
      justify-content: center;
    }
    &__context {
      flex: 1 1 180px;
      margin-right: 8px;
    }
    &__wrapper {
      flex: 1 1 180px;
      margin-right: 8px;
    }
    &__count {
      flex: 0 0 32px;
      display: flex;
      justify-content: center;
    }
    &__link {
      flex: 0 0 80px;
      margin-right: 8px;
    }
    &__edit {
      flex: 0 0 32px;
      display: flex;
      justify-content: center;
    }
    &__more {
      flex: 0 0 32px;
      display: flex;
      justify-content: center;
    }
  }

`;

export const DefaultCreativeSkeletonStyled = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 0 12px;
  height: 40px;
  margin-bottom: 8px;
  background: ${props => props.theme.uiColors.boxBgColor01};
  border: 1px solid ${props => props.theme.uiColors.tableListRowBorder};
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);

  .defaultCreativeSkeleton__label {
    flex: 0 0 160px;
  }
  .defaultCreativeSkeleton__select {
    display: flex;
    justify-content: flex-end;
    flex: 1 1 220px;
  }
`;
